<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "chevron-down" });
export let css = "";
export let isScaling = true;
</script>

<svg xmlns = 'http://www.w3.org/2000/svg'
    fill = 'none'
    viewBox = '0 0 20 20'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <path
        d = 'M5 7.5L10 12.5L15 7.5'
        stroke-width = '1.5'
        stroke-linecap = 'round'
        stroke-linejoin = 'round'
        vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }>
    </path>
</svg>